import microuniversoApi from "app/api/microuniversoApi";
import { FiltroPesquisaProdutos } from "app/types/produto/FiltroPesquisaProdutos";
import { IProduto } from "app/types/produto/IProduto";

export async function pesquisarProdutos(filtro: FiltroPesquisaProdutos) : Promise<IProduto[]> {
    const produtos = microuniversoApi.Produto.pesquisar(filtro)

    return produtos
}